import isEmpty from "./isEmpty";

export default isEmpty;
